module.exports = __webpack_public_path__ + "img/dosan-avatar.1c6beed7.png";